import {Entity} from 'smag-commons/cfg/hierarchy';

/**
 * A single possible choice for an "enum" parameter.
 */
export interface EnumValue {
    value: any;
    name: string;
}

/**
 * Checks whether the given device *key* is *physically* configured for the given {@link Entity entity},
 * i.e. that it is "connected" to a field device.
 *
 * @param entity    The entity
 * @param deviceKey The entity device's key
 * @return Whether the entity device is configured on the connectivity layer
 */
export function hasFieldEntityDevice(entity: Entity, deviceKey: string): boolean {
    // NOTE: deviceKey is a "key" (i.e. device "type" like "average_absorbed_power")
    return !!(entity.connector_devices || {})[deviceKey];
}
